export const SCREEN_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export const SCREENS = {
  MOBILE_AND_SMALL_TABLET: '(width < 1024px)',
  DESKTOP_AND_LARGE_TABLET: '(width >= 1024px)',
  DESKTOP_AND_LARGE_TABLET_AND_SMALL_TABLET: '(width < 1400px)',
};

export function getBreakpoint(width = window.innerWidth) {
  const breakpoints = Object.entries(SCREEN_BREAKPOINTS).sort((a, b) => a[1] - b[1]);

  let current = 'base';

  for (const [key, minWidth] of breakpoints) {
    if (width >= minWidth) {
      current = key;
    }
  }

  return current;
}
